export default __webpack_public_path__ + "static/media/kou-homepage.11c7f5f3.png";